import btoa from "btoa-lite";
import { isAuthorizationRoute } from "./is-authorization-route";
import { getToken } from "./get-token";
import { requestWith2Fa } from "./request-with-2fa";
export async function hook(state, request, route, parameters) {
    const endpoint = request.endpoint.merge(route, parameters);
    const basicAuthorization = `basic ${btoa(`${state.strategyOptions.username}:${state.strategyOptions.password}`)}`;
    if (isAuthorizationRoute(endpoint.url)) {
        endpoint.headers.authorization = basicAuthorization;
        return requestWith2Fa(state, endpoint, request);
    }
    const { token } = await getToken(state, {}, request);
    endpoint.headers.authorization = `token ${token}`;
    return request(endpoint);
}
